import React from "react";

export default function Recruitment(props) {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6 text-yellow-500">
        Recruitment and training of SS/KVS staff
      </h1>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            Slum Soccer/ Krida Vikas Sanstha recognizes that some individuals
            actively seek employment or voluntary work with children in order to
            harm them. Even otherwise, anyone may have the potential to harm
            and/or abuse children in some way. Therefore, all reasonable steps
            shall be taken to ensure that such depraved perpetrators of child
            harm and child abuse are prevented from working with children. To
            ensure the same, pre selection checks by HR Dept. shall include the
            following:
          </span>
          <ul className="space-y-2 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                All staff shall complete an application form. The application
                form will elicit information about an applicant's past and a
                self-disclosure about any criminal record.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Two confidential references, including one regarding previous
                work should be obtained. These references must be taken up and
                confirmed through telephone contact.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Evidence of identity (passport or driving license or Aadhar card
                with photo).
              </span>
            </li>
          </ul>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            Interview and Induction
          </h2>
          <span className="text-gray-700 block mb-1">
            All SS/KVS staff shall undergo an interview and induction, during
            which:
          </span>
          <ul className="space-y-2 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                A check shall be made that the application form has been
                completed in full (including sections on criminal records and
                self-disclosures).
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Their qualifications shall be substantiated.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                The job requirements and responsibilities shall be clarified.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Child safeguarding and protection procedures shall be explained
                and training needs shall be identified.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                They should sign up to the organization’s Code of Conduct and
                Child Safeguarding & Protection Policy.
              </span>
            </li>
          </ul>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">Training</h2>
          <span className="text-gray-700 block mb-1">
            SS/KVS staff shall undergo post-recruitment training conducted by HR
            Dept. to help them to:
          </span>
          <ul className="space-y-2 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Analyze their own practices against established good practices
                with a view to prevent their actions being misunderstood as
                abuse or inappropriate.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Recognize their responsibilities and report any concerns about
                suspected poor practice or possible abuse.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Respond with sensitivity and without being judgmental to
                concerns expressed by a child.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Work safely with children keeping safety and welfare of the
                child foremost.
              </span>
            </li>
          </ul>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            HR Dept. of Slum Soccer/ Krida Vikas Sanstha shall ensure:
          </span>
          <ul className="space-y-2 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                All SS/KVS staff shall periodically attend a Child Safeguarding and Protection 
awareness/ refresher training, to ensure their actions are ethical and to facilitate the 
development of a positive culture towards good practices associated with Child 
Safeguarding & Protection
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Relevant personnel shall gain first aid training.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
